<script>
import Parse from 'parse'
import EventBus from '@/EventBus'
import moment from 'moment-timezone'
import { clearLocalStorage } from '@/components/cache'

export default {
  methods: {
    async parseLogout() {
      let res
      res = await Parse.User.logOut()
      clearLocalStorage()
      return res
    },
    async getSlackUsers(code, redirectUrl) {
      return await this.run('getSlackUsers', {
        code,
        redirectUrl,
      })
    },
    async getTokenDetails(token, teamInvitationUrlToken) {
      return await this.run('getTokenDetails', {
        token: token,
        teamInvitationUrlToken: teamInvitationUrlToken,
      })
    },

    async loginWithSlack(code) {
      return await this.run('loginWithSlack', {
        code,
      })
    },
    async setTeamAvatar(teamId, base64Avatar) {
      return await this.run('setTeamAvatar', {
        teamId,
        base64Avatar,
      })
    },
    async sendUserFeedback(message, userId, type) {
      return await this.run('sendUserFeedback', {
        message,
        userId,
        type,
      })
    },
    async deleteUser(password) {
      return await this.run('deleteUser', {
        password,
      })
    },
    async deleteTeam(teamId, password, teamName) {
      return await this.run('deleteTeam', {
        teamId,
        password,
        teamName,
      })
    },
    async cancelSubscription(teamId) {
      return await this.run('cancelSubscription', {
        teamId,
      })
    },
    async retryPayment(teamId) {
      return await this.run('retryPayment', {
        teamId,
      })
    },
    async restoreSubscription(teamId) {
      return await this.run('createOrUpdateSubscription', {
        isRestoration: true,
        teamId,
      })
    },
    async switchSubscription(plan, teamId, paymentMethodId, currency) {
      return await this.run('createOrUpdateSubscription', {
        plan,
        teamId,
        paymentMethodId,
        currency,
      })
    },
    async createSubscriptionEU(
      companyName,
      countryCode,
      plan,
      isCompany,
      teamId,
      paymentMethodId,
      line1,
      line2,
      city,
      stateProvince,
      zipCode,
      vatId,
      currency,
    ) {
      return await this.run('createOrUpdateSubscription', {
        companyName,
        countryCode,
        plan,
        isCompany,
        teamId,
        paymentMethodId,
        line1,
        line2,
        city,
        stateProvince,
        zipCode,
        vatId,
        currency,
      })
    },
    async createSubscriptionNonEU(companyName, countryCode, plan, isCompany, teamId, paymentMethodId, line1, line2, city, stateProvince, zipCode, currency) {
      return await this.run('createOrUpdateSubscription', {
        companyName,
        countryCode,
        plan,
        isCompany,
        teamId,
        paymentMethodId,
        line1,
        line2,
        city,
        stateProvince,
        zipCode,
        currency,
      })
    },
    async updateSubscriptionDetailsEU(companyName, countryCode, isCompany, teamId, line1, line2, city, stateProvince, zipCode, vatId) {
      return await this.run('createOrUpdateSubscription', {
        companyName,
        countryCode,
        isCompany,
        teamId,
        line1,
        line2,
        city,
        stateProvince,
        zipCode,
        vatId,
      })
    },
    async resendInvitationParse(teamId, teamMemberId) {
      return await this.run('resendInvitation', {
        teamId,
        teamMemberId,
      })
    },
    async updateSubscriptionDetailsNonEU(companyName, countryCode, isCompany, teamId, line1, line2, city, stateProvince, zipCode, vatId) {
      return await this.run('createOrUpdateSubscription', {
        companyName,
        countryCode,
        isCompany,
        teamId,
        line1,
        line2,
        city,
        stateProvince,
        zipCode,
      })
    },
    async changeCardNumberPaymentId(teamId, paymentMethodId) {
      return await this.run('createOrUpdateSubscription', {
        teamId,
        paymentMethodId,
      })
    },

    async getCountries() {
      return await this.run('countries', {})
    },
    async getVatRates() {
      return await this.run('getVatRates', {})
    },
    async changeEmailRequest(newEmail, password) {
      return await this.run('changeEmailRequest', {
        newEmail,
        password,
      })
    },
    async changeEmail(newEmail, token) {
      return await this.run('changeEmail', {
        newEmail,
        token,
      })
    },
    async magicLink(email, invitationToken, teamInvitationUrlToken) {
      return await this.run('magicLink', {
        email,
        'invitation-token': invitationToken,
        'team-invitation-url-token': teamInvitationUrlToken,
      })
    },

    /*async createSubscription(card) {
            try {
                return await this.run('createSubscription', {card})
            } catch (e) {
                console.error('Error while running stripe.createSubscription :\n', +JSON.stringify(e) +
                    +'\n' + e.toString())
            }
        },*/
    async createPaymentMethod(type, card, billing_details) {
      var ret = await this.stripe.createPaymentMethod({
        type,
        card,
        billing_details,
      })
      if (ret.error) {
        return ret
      } else {
        return ret.paymentMethod
      }

      return ret
    },
    async getPaymentDetails(teamId, locale, countryCode, language) {
      return await this.run('getPaymentDetails', {
        teamId,
        locale,
        countryCode,
        language,
      })
    },
    async setTeamMemberNotificationSettings(teamId, notificationSettings) {
      return await this.run('setTeamMemberNotificationSettings', {
        teamId,
        notificationSettings,
      })
    },
    async getSubscriptionPriceDetails(countryCode, teamId, plan, locale, isCompany) {
      // plan: standardMonthly, standardYearly, proMonthly, proYearly
      return await this.run('getSubscriptionPriceDetails', {
        countryCode,
        teamId,
        plan,
        locale,
        isCompany,
      })
    },
    async deleteNotification(notificationId) {
      return await this.run('deleteNotification', {
        notificationId,
      })
    },
    async sleep(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms))
    },
    async getMyTeamMemberId(teamId) {
      return await this.run('getMyTeamMemberId', {
        teamId,
      })
    },
    async deleteTeamMember(teamMemberId) {
      return await this.run('deleteTeamMember', {
        teamMemberId,
        leftOrDeleted: 'deleted',
      })
    },
    async leaveTeam(teamMemberId) {
      return await this.run('deleteTeamMember', {
        teamMemberId,
        leftOrDeleted: 'left',
      })
    },
    async cancelInvitation(teamId) {
      return await this.run('cancelInvitation', {
        teamId: teamId,
      })
    },
    async getTeamMemberInvitationLink(teamId) {
      return await this.run('getTeamMemberInvitationLink', {
        teamId,
      })
    },
    async getEntries(start, end, groupBy, page, usersPerPage, searchPhrase) {
      return await this.run('entries', {
        start,
        end,
        groupBy,
        page,
        usersPerPage,
        searchPhrase,
      })
    },
    async getEntriesWithTeamId(start, end, teamId, groupBy, page, usersPerPage, searchPhrase) {
      return await this.run('entries', {
        start,
        end,
        teamId,
        groupBy,
        page,
        usersPerPage,
        searchPhrase,
      })
    },
    async getEntriesWithUserId(start, end, userId) {
      return await this.run('entries', {
        start,
        end,
        userId,
      })
    },
    async getTeamUpdates(teamId, userSettings, minDate) {
      const weekStart = userSettings['week-start'] ? userSettings['week-start'] : 'Sunday'
      const timezone = Parse.User.current().get('timezone')
      const locale = this.$i18n.locale
      const is24h = this.$store.state.userSettings['is-24h']
      let ret

      ret = await this.run('getUpdates', {
        teamId,
        weekStart,
        timezone,
        locale,
        is24h,
        minDate,
      })

      return ret
    },
    async getOverdueStatus(teamId) {
      const timezone = Parse.User.current().get('timezone')
      const locale = this.$i18n.locale
      const is24h = this.$store.state.userSettings['is-24h']

      return await this.run('getOverdueStatus', {
        teamId,
        timezone,
        locale,
        is24h,
      })
    },
    async resetPassword(email, password, token) {
      return await this.run('resetPassword', {
        email,
        password,
        token,
      })
    },

    async changePassword(oldPassword, newPassword) {
      return await this.run('changePassword', {
        oldPassword,
        newPassword,
      })
    },

    async resetPasswordRequest(email) {
      return await this.run('resetPasswordRequest', {
        email,
      })
    },
    async getInvoices(teamId, locale) {
      return await this.run('invoices', {
        teamId,
        locale,
      })
    },
    async getIntegrations(teamId) {
      return await this.run('getIntegrations', {
        teamId,
      })
    },
    async getUsersNotInIntegration(teamId, system, useCache) {
      return await this.run('getUsersNotInIntegration', {
        teamId,
        system,
        useCache,
      })
    },
    async getIntegrationUnmatchedUsers(teamId, system) {
      return await this.run('getIntegrationUnmatchedUsers', {
        teamId,
        system,
      })
    },
    async getIntegrationSettings(teamId, system) {
      return await this.run('getIntegrationSettings', {
        teamId,
        system,
      })
    },
    async setIntegrationSettings(teamId, system, settings) {
      return await this.run('setIntegrationSettings', {
        teamId,
        system,
        settings,
      })
    },
    async setHolidayDays(teamMemberId, year, holidayDays) {
      return await this.run('setHolidayDays', {
        teamMemberId,
        year,
        holidayDays,
      })
    },
    // async getPaymentMethods(teamId) {
    //   return await this.run('paymentMethods', {
    //     teamId: teamId,
    //   })
    // },
    async addTeamMemberByUrl(token) {
      return await this.run('addTeamMemberByUrl', {
        token,
      })
    },
    async addTeamMember(email, teamId, timezone, fullName, system, externalUserId) {
      return await this.run('addTeamMember', {
        email,
        onlyCompanyDomain: false,
        teamId,
        timezone,
        fullName,
        system,
        externalUserId,
      })
    },
    async logInUser(email, password) {
      return await Parse.User.logIn(email, password, {})
    },
    async SignUpClavoUser(email, fullName, password, timezone, token, locale) {
      return await this.run('SignUpClavoUser', {
        username: email,
        fullName,
        email,
        password,
        timezone,
        token,
        locale,
      })
    },
    async confirmMail(email, token) {
      return await this.run('confirmMail', {
        email,
        token,
      })
    },
    async checkIfEmailConfirmed(email, tokenId) {
      return await this.run('checkIfEmailConfirmed', {
        email,
        tokenId,
      })
    },
    async confirmTeamMember(email, token) {
      return await this.run('confirmTeamMember', {
        email,
        token,
      })
    },
    async createTeamParse(teamName) {
      return await this.run('createTeam', {
        teamName,
      })
    },
    async setTeamName(teamId, name) {
      return await this.run('setTeamName', {
        teamId,
        name,
      })
    },
    async acceptExistingUserInvitation(teamId, token, type) {
      return await this.run('confirmTeamMember', {
        teamId,
        token,
        type,
      })
    },
    async checkInvitedUser(email, token) {
      return await this.run('checkInvitedUser', {
        email,
        token,
      })
    },
    async overwriteAccount(email, fullName, password, timezone, token) {
      return await this.run('overwriteAccount', {
        email,
        fullName,
        timezone,
        password,
        token,
      })
    },
    async checkIfCanDeleteUser() {
      return await this.run('checkIfCanDeleteUser', {})
    },
    async getTeamMembers(teamId, page, keyword, itemsPerPage) {
      let res = await this.run('teamMembers', {
        teams: [teamId],
        page,
        keyword,
        itemsPerPage,
      })
      return res
    },
    // async addTeamLocation(name, timezone, color, teamId) {
    //   return await this.run('addLocation', {
    //     teamId: teamId,
    //     name: name,
    //     timezone: timezone,
    //     color: color,
    //   })
    // },
    async getLocations(teamId) {
      let arg = teamId ? { teamId } : {}
      let response = await this.run('locations', arg)
      /*// console.log('get loc map id: ', teamId, response.map(parseObj => Object.assign(
                {}, parseObj.attributes, {id: parseObj.id}))) // does the same but more complicated*/
      return await JSON.parse(JSON.stringify(response))
    },
    async getTeams() {
      let res = await this.run('teams', {})
      // return [...res.teams]
      return res
    },
    async getTimezones() {
      let res = await this.run('timezones', {})
      return res.timezones.map((z) => new Object({ value: z.zoneName, name: z.zoneName, countryCode: z.countryCode, countryName: z.countryName, map: z.map }))
    },
    async getFormattedTimezones() {
      let timezones = await this.getTimezones()
      for (let tz of timezones) {
        let loc = tz.value.split('/')
        let city = loc[loc.length - 1].replaceAll('_', ' ')
        let tzStr
        if (city === tz.countryName) {
          tzStr = tz.countryName
        } else {
          tzStr = city + ', ' + tz.countryName
        }

        // for (let j = 0; j < loc.length - 1; j++) {
        //   if (loc[loc.length - 2 - j].replaceAll('_', ' ') !== tz.countryName) {
        //     tzStr = tzStr + ', ' + loc[loc.length - 2 - j].replaceAll('_', ' ')
        //   }
        // }
        if (tzStr.startsWith('South Georgia, ')) {
          tzStr = tzStr.replace('South Georgia, ', '')
          tzStr = tzStr.replace('and', '&')
        }
        tz.name = tzStr
        tz.momentsName = tz.value
        tz.utc = this.timezoneFormat(tz.value)
        tz.city = city
      }
      this.$store.commit('setTimezones', timezones)
      return timezones
    },
    timezoneFormat(timezone) {
      return ' (UTC ' + moment().tz(timezone).format('Z') + ')'
    },
    async getTeamById(id) {
      let res = await this.run('teams', {
        teamId: id,
      })
      if (res.status === 'ok') {
        this.$store.commit('updateOneTeam', res.teams[0])
        return res.teams[0]
      } else {
        return null
      }
    },
    async addLocation(name, color, teamId, singleLocation, timezone, type) {
      return await this.run('addLocation', {
        name,
        color,
        teamId,
        singleLocation,
        timezone,
        type,
      })
    },
    async editLocation(locationId, name, color, singleLocation, timezone, type) {
      return await this.run('editLocation', {
        locationId,
        name,
        color,
        singleLocation,
        timezone,
        type,
      })
    },
    async deleteLocation(locationId) {
      // console.log('aaa')
      return await this.run('deleteLocation', {
        locationId,
      })
    },
    async changeRole(teamMemberId, role) {
      return await this.run('changeRole', {
        teamMemberId,
        role,
      })
    },
    async disableOrEnableTeamMember(teamMemberId, active) {
      return await this.run('disableOrEnableTeamMember', {
        teamMemberId,
        active,
      })
    },
    async updateTeamSettings(teamId, dbname, value) {
      return await this.run(
        'updateTeamSettings',
        {
          teamId,
          settings: {
            [dbname]: value,
          },
        },
        {},
      )
    },
    async updateTeamSettingsCollectively(teamId, settingsObject, mode) {
      return await this.run(
        'updateTeamSettings',
        {
          teamId,
          settings: settingsObject,
          mode,
        },
        {},
      )
    },
    async deactivateInvitationLink(teamId) {
      return await this.run('deactivateInvitationLink', {
        teamId,
      })
    },
    async regenerateInvitationLink(teamId) {
      return await this.run('regenerateInvitationLink', {
        teamId,
      })
    },
    async watchedAndNotWatched() {
      return await this.run('watchedAndNotWatched', {})
    },
    async addToWatchlist(userId) {
      return await this.run('addToWatchlist', {
        userId,
      })
    },
    async removeFromWatchlist(userId) {
      return await this.run('removeFromWatchlist', {
        userId,
      })
    },
    async userSettingsCLAPI(watchlistId) {
      return await this.run('userSettings', { watchlistId })
    },
    async setUserSetting(dbname, value) {
      return await this.run('setUserSetting', {
        [dbname]: value,
      })
    },
    async setWatchlistNotificationSetting(key, value, watchlistId) {
      return await this.run('setWatchlistNotificationSetting', {
        watchlistId,
        setting: { key, value },
      })
    },
    async generateLocations(teamId, locations) {
      return await this.run('generateLocations', {
        teamId,
        locations,
      })
    },
    async submitEntries(entries, weekStart, weekEnd, timezone, userId) {
      return await this.run(
        'submitEntries',
        {
          entries,
          weekStart,
          weekEnd,
          timezone,
          userId,
        },
        'submitEntries',
      )
    },
    async userLogIn(email, password) {
      return await this.run('LOGIN', { email, password })
    },
    async removeIntegration(teamId, system) {
      return await this.run('removeIntegration', { teamId, system })
    },
    async getIntegrationInstallUrl(teamId, calledFrom, system) {
      return await this.run('getIntegrationInstallUrl', { teamId, calledFrom, system })
    },
    async verifyIntegrationStateAndApproveInstall(code, state, system, guild_id) {
      return await this.run('verifyIntegrationStateAndApproveInstall', {
        code,
        state,
        system,
        guild_id,
      })
    },
    async assignExternalIdsToClavoTeamMembers(teamId, system) {
      return await this.run('assignExternalIdsToClavoTeamMembers', {
        teamId,
        system,
      })
    },

    async connectExternalUser(system, teamId, teamMemberId, externalUserId) {
      return await this.run('connectExternalUser', {
        system,
        teamId,
        teamMemberId,
        externalUserId,
      })
    },

    async disconnectExternalUser(system, teamId, teamMemberId) {
      return await this.run('disconnectExternalUser', {
        system,
        teamId,
        teamMemberId,
      })
    },

    async run(functionName, argsObj, callbackName) {
      try {
        let res
        if (functionName === 'LOGIN') {
          res = await Parse.User.logIn(argsObj.email, argsObj.password, {})
        } else {
          res = await Parse.Cloud.run(functionName, argsObj, {})
        }
        // console.log('PARSE RESPONSE NO ERROR', res)
        //141 code == logged out/session expired ; 209 code == logged out/invalid token
        if (callbackName) {
          EventBus.$emit('parse-' + callbackName, res)
        }
        EventBus.$emit('serverAvailable')
        return res
      } catch (e) {
        console.log('ERROR', e)
        if (callbackName) {
          EventBus.$emit('parse-' + callbackName, {
            ...e,
            status: 'exception',
          })
        }
        // e.error = 'yes'
        // console.log('PARSE ERROR', e)
        if (e.code === 100) {
          // Unable to connect to the Parse API
          EventBus.$emit('serverNotAvailable', { functionName, argsObj, callbackName })
        } else if (e.code == 209) {
          await this.$router.push({ path: '/login' })
          EventBus.$emit('new-info-bar-msg', {
            msg: this.$t('youHaveBeenLoggedOut'),
          })
          // } else if(e.code == 141){
          //   await this.$router.push({path: '/login'})
          //   EventBus.$emit('new-info-bar-msg', {
          //     msg: this.$t('youHaveBeenLoggedOut'),
          //     error: true,
          //   })
        } else {
          EventBus.$emit('server-request-problem', {
            msg: this.$t(e.message),
          })
        }
        return e
      }
    },
    async getPriceOfOneUnitNoTax(countryCode, plan, locale, currency) {
      return await this.run('getPriceOfOneUnitNoTax', {
        countryCode,
        plan,
        locale,
        currency,
      })
    },
    async getPaymentStatus(teamId, plan) {
      return await this.run('getPaymentStatus', {
        teamId,
        plan,
      })
    },
  },
}
</script>
